// Based od EasySoftware\CMS\PuxOrchard.Content.Editor\Views\Content_CollaborationBar.cshtml

import Tooltip from "@material-ui/core/Tooltip";
import React, { useEffect, useMemo, useState } from "react";
import './EasySoftwareActiveEditors.scss';

type ActiveEditor = {
    userName: string;
    active: boolean;
    lastActive: string;
    x: number;
    y: number;
};

interface Props {
    contentItemPath: string;
}

const EasySoftwareActiveEditors: React.FC<Props> = ({ contentItemPath }) => {
    const [editors, setEditors] = useState<ActiveEditor[]>([]);
    const [error, setError] = useState(false);

    const encodedPath = encodeURIComponent(contentItemPath);
    const baseUrl = process.env.GATSBY_ORCHARD_API_URL;

    const getEditorSignature = (editors: ActiveEditor[]) =>
        editors.map(e => `${e.userName}|${e.lastActive}|${e.active}`).join(";");

    useEffect(() => {
        const updateBar = async () => {
            try {
                const res = await fetch(`${baseUrl}/puxapi/collaboration/active-editors?path=${encodedPath}`, {
                    credentials: "include",
                });
                const json: ActiveEditor[] = await res.json();
                setError(false);

                setEditors((prev) => {
                    if (getEditorSignature(prev) !== getEditorSignature(json)) {
                        return json;
                    }
                    return prev;
                });

            } catch (err) {
                console.error("Active editors bar fetch error:", err);
                setError(true);
            }
        };

        updateBar();
        const updateInterval = setInterval(updateBar, 15000);

        return () => {
            clearInterval(updateInterval);
        };
    }, [baseUrl, encodedPath]);

    useEffect(() => {
        const pingInterval = setInterval(() => {
            fetch(`${baseUrl}/puxapi/collaboration/register-editor?path=${encodedPath}`, {
                credentials: "include",
            }).catch((err) => {
                console.error("Active editors resgister error:", err);
            });
        }, 1500);

        return () => {
            clearInterval(pingInterval);
        };
    }, [baseUrl, encodedPath]);

    if (error) {
        return (
            <div className="CollaborationBar CollaborationBar--error">
                <div className="CollaborationBar-message">
                    Unable to fetch editor activity.
                </div>
            </div>
        );
    }

    return (
        editors.length > 0 ? (
            <div className="CollaborationBar">
                <div className="CollaborationBar-message">
                    Multiple users are currently working on this item:
                </div>
                <div className="CollaborationBar-people">
                    {editors.map((item, index) => {
                        const activityDate = item.lastActive ? new Date(item.lastActive) : null;
                        const formattedDate = activityDate && !isNaN(activityDate.getTime())
                            ? activityDate.toLocaleString()
                            : "Unknown";

                        const tooltipMessage = (
                            <div className="CollaborationBar-tooltip">
                                <span className="CollaborationBar-tooltipTitle">{item.userName}</span>
                                <br />
                                <span>last activity: {formattedDate}</span>
                            </div>
                        );

                        const personClassNames = [
                            "CollaborationBar-person",
                            `is-user${index}`,
                            !item.active && "is-notActive"
                        ]
                            .filter(Boolean)
                            .join(" ");

                        return (
                            <Tooltip key={item.userName} title={tooltipMessage} placement="right" arrow>
                                <div className={personClassNames}>
                                    {item.userName.substring(0, 2).toUpperCase()}
                                </div>
                            </Tooltip>
                        );
                    })}
                </div>
            </div>
        ) : null
    );
};

export default EasySoftwareActiveEditors;
